import React from 'react';

import NumberFormat from 'react-number-format';

const priceDisplay = ({price, hideAlternative}) => {

    if(price === 0 && !hideAlternative){
        return (
            <span>Inbegrepen</span>
        )
    }else{
        return (
            <NumberFormat
                thousandSeparator="."
                fixedDecimalScale={true}
                decimalSeparator=","
                decimalScale={2}
                value={price}
                displayType={'text'}
                prefix={'€'}
            />
        )
    }
}

export default priceDisplay;


// WEBPACK FOOTER //
// ./src/components/reservationForm/priceDisplay.js